import './App.css';
import { useEffect } from 'react';
import Desktop from './components/os/Desktop';

function App() {
    const isInIframe = typeof window !== 'undefined' && window.self !== window.top;

    useEffect(() => {
        if (isInIframe && window.parent) {
            window.parent.postMessage({ type: 'inner-loaded' }, '*');
        }
    }, [isInIframe]);

    return (
        <div className="App">
            <Desktop isInIframe={isInIframe} />
        </div>
    );
}

export default App;
